import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectors, stateKeys } from '../../../model';
import { stepKeys } from '../../../config/step';
import { importTypes } from '../../../config/import';
import { uploadingFieldNames } from '../../../config/uploadingStep';
import UploadingStep from './UploadingStep/UploadingStep';
import SettingStep from './SettingStep/SettingStep';
import PreviewStep from './PreviewStep/PreviewStep';
import StepContainer from '../../ui/StepContainer/StepContainer';
import Result from './Result/Result';

const { selectStateValue, selectUploadingStepValue } = selectors;

const stepSelector = (state) => selectStateValue(state, stateKeys.step);
const houseSelector = (state) =>
  selectUploadingStepValue(state, uploadingFieldNames.house);
const importTypeSelector = (state) =>
  selectUploadingStepValue(state, uploadingFieldNames.importType);

const importTypeTitles = {
  [importTypes.owners]: 'собственников',
  [importTypes.personalAccounts]: 'лицевых счетов',
  [importTypes.personalAccountsByCompanies]: 'лицевых счетов по УК',
  [importTypes.individualMeters]: 'ИПУ',
};

const stepsWithHouseTitle = new Set([stepKeys.setting, stepKeys.preview]);

const components = {
  [stepKeys.uploading]: UploadingStep,
  [stepKeys.setting]: SettingStep,
  [stepKeys.preview]: PreviewStep,
  [stepKeys.result]: Result,
};

export const useStepTitle = () => {
  const step = useSelector(stepSelector);
  const house = useSelector(houseSelector);
  const importType = useSelector(importTypeSelector);

  return useMemo(() => {
    const importTypeTitle = importTypeTitles[importType];
    const houseAddress = house?.label;

    if (!stepsWithHouseTitle.has(step) || !importTypeTitle) {
      return undefined;
    }

    if (importType === importTypes.personalAccountsByCompanies) {
      return 'Импорт лицевых счетов по УК';
    }

    if (!houseAddress) return undefined;

    return `Импорт ${importTypeTitle} по дому ${houseAddress}`;
  }, [house, importType, step]);
};

const Step = ({ className }) => {
  const step = useSelector(stepSelector);

  const Component = useMemo(() => components[step], [step]);

  return Component ? (
    <StepContainer className={className}>
      <Component />
    </StepContainer>
  ) : null;
};

export default Step;
